import React, {Component, Fragment} from "react";
import ReactSwipe from 'react-swipe';
import {BrowserView, isMobile} from 'react-device-detect';

import {formatPrice, isEmpty, objectCompare, toggleState} from "../../lib/tools";
import {Button} from "../common/common";
import {getImage} from "../../lib/api";
//Icons
import CloseIcon from "../../resources/icons/x-black.svg";
import navArrowIcon from "../../resources/icons/drop-white.svg";
// Images
import {reduxWrapper} from "../../globalState";

export class QuestonSwipeSlider extends Component {
	state = {
		location: 0,
		toggle: false
	};
	
	shown = {};
	lastShown = {};
	
	render() {
		const {className, children, outer = false} = this.props;
		let reactSwipeEl;
		
		const childList = [];
		const hiddenChildren = [];
		
		React.Children.forEach(children, (x, i) => {
			const child = React.cloneElement(x, {isShown: shown => this.shown[i] = shown});
			if (this.shown[i]) childList.push(child);
			else hiddenChildren.push(child);
		});
		
		this.shown = {};
		
		let classes = ["sliderWrapper"];
		outer && classes.push("outerSlider");
		childList.length < 1 && classes.push("hidden");
		className && classes.push(className);
		
		return (
			<div className={classes.join(" ")}>
				{outer && !isMobile &&
				<div className="sliderText">
					<p>
						Gæsterne kommer ikke på samme tid, så giv gæsterne en drink og snacks efterhånden som de
						ankommer.
					</p>
				</div>
				}
				{/* The swipeable card */}
				<div className="swiperWrapper">
					<ReactSwipe
						swipeOptions={{
							startSlide: this.state.location,
							continuous: false,
							//callback: (index) => console.log(index),
							transitionEnd: (index) => {
								this.setState({location: index})
							}
						}}
						ref={el => (reactSwipeEl = el)}
						style={{wrapper: {display: 'flex'}}}
						childCount={childList.length}
					>
						{childList}
					</ReactSwipe>
					
					<div className="hidden" style={{display: "none"}}>
						{hiddenChildren}
					</div>
					
					{/*Slider Navigation btns for desktop view */}
					{childList.length > 1 &&
					<div className="sliderNavigation">
						{this.state.location > 0 &&
						<BrowserView renderWithFragment>
							<div className="navBtn navBtnPrev" onClick={() => reactSwipeEl.prev()}>
								<img src={navArrowIcon} alt="Forrige"/>
							</div>
						</BrowserView>
							
						}
						{this.state.location < (childList.length - 1) &&
						<BrowserView renderWithFragment>
							<div className="navBtn navBtnNext" onClick={() => reactSwipeEl.next()}>
								<img src={navArrowIcon} alt="Næste"/>
							</div>
						</BrowserView>
						}
					</div>
					}
					
					{/* The slider location indicator */}
					{
						childList.length > 1 &&
						<div className="sliderLocation">
							{childList.map((x, i) =>
								<span className={this.state.location === i ? "dotFilled" : "dotEmpty"} key={i}/>
							)}
						</div>
					}
				</div>
			</div>
		)
	}
	
	componentDidUpdate(prevProps, prevState, snapshot) {
		if (!objectCompare(this.shown, this.lastShown)) this.setState(toggleState("toggle"));
		this.lastShown = this.shown;
	}
}


export class InfoCard extends Component {
	state = {};
	
	render() {
		const {question: {title, text, image}} = this.props;
		return (
			<div className="infoCard">
				<div className="imgWrapper" style={{backgroundImage: `url(${getImage(image)})`}}/>
				<div className="textWrapper">
					<h3 className="infoCardTitle">{title}</h3>
					<p className="infoCardText">{text}</p>
				</div>
			</div>
		)
	}
}

class UpsaleCardRender extends Component {
	state = {
		flipped: false,
		hideFront: false,
		flipping: false
	};
	
	toggleFlip = () => {
		this.setState(toggleState("flipped"));
		this.setState(toggleState("showQuestions"));
		this.setState(toggleState("flipping"));
		
		setTimeout(() => {
			this.setState(toggleState("hideFront"));
		}, 200);
		setTimeout(() => {
			this.setState(toggleState("showQuestions"));
			this.setState(toggleState("flipping"));
		}, 500);
	};

	hideQuestion = () => {
		this.props.setPartyInfo({data: {questions: [...(this.props.partyInfo.questions || []), this.props.question.id]}});
	}
	
	addToCart = () => {
		this.props.addMultipleToCart({
			products: this.props.question.products.map(x => ({...x, sectionParent: this.props.tile.id}))
		}).then(() => {
			this.hideQuestion();
		});
	};

	
	render() {
		const {question, products} = this.props;
		return (
			<div className={[
				"flip-container",
				this.state.flipped ? "flip" : "",
				this.state.flipping ? "flipping" : "",
			].join(" ")}>
				<section className="flipper">
					<div className="sliderCard">
						<div className={this.state.hideFront ? "hideFront" : "front"}>
							{question.products &&
							<img src={CloseIcon} onClick={() => this.toggleFlip()}/>
							}
							<h1 className="qTitle">{question.question}</h1>
							{question.products && !isEmpty(products) ?
								<Fragment>
									{question.products.map((x, i) =>
										products[x.productId] &&
										<div key={i} className="qProductWrapper">
											<img src={getImage(products[x.productId].thumbnail)}
											     alt={products[x.productId].name}/>
											<div className="qProductInfo">
												<span className="prodName">{x.qty} x {products[x.productId].name}</span>
												<span
													className="prodPrice">{formatPrice(products[x.productId].price * x.qty)}</span>
											</div>
										</div>
									)}
									<Button onClick={() => this.addToCart()}>Ja tak, tilføj</Button>
								</Fragment> :
								<Fragment>
									<div className="qActionBtnsWrapper">
										<Button className="light" onClick={() => this.toggleFlip()}>Nej tak</Button>
										{
											question.link ? 
											<Button to={question.link} onClick={() => this.hideQuestion()}>Ja</Button> : 
											<Button>Hvis hvad i har</Button>
										}
									</div>
								</Fragment>
							}
						</div>
						
						<div className={this.state.hideFront ? "back" : "hideBack"}>
							<span>{question.back}</span>
							<Button onClick={() => this.toggleFlip()}>Ok, hvis mig hvad i har</Button>
						</div>
					</div>
				</section>
			</div>
		)
	}
}

export const UpsaleCard = reduxWrapper("getAddMultipleToCart", "setPartyInfo", "loadPartyInfo")(UpsaleCardRender);




// WEBPACK FOOTER //
// ./src/components/common/cardSlider.js